export const GET_USER_PORTAL_AUDIT_LOGS_REQUEST = "GET_USER_PORTAL_AUDIT_LOGS_REQUEST";
export const GET_USER_PORTAL_AUDIT_LOGS_SUCCESS = "GET_USER_PORTAL_AUDIT_LOGS_SUCCESS";
export const GET_USER_PORTAL_AUDIT_LOGS_FAIL = "GET_USER_PORTAL_AUDIT_LOGS_FAIL";
